{
    "coordinates": [
        -30.361823619343575,
        22.508286130808585
    ],
    "tooltip": "Tapinocephalus Assemblage Zone",
    "title": "Tapinocephalus Assemblage Zone",
    "country": "South Africa",
    "period": "Permian",
    "alt": "TODO"
}